import React, { useEffect, useState } from "react";
import config from "../config/config";
import { Container, Row, Col, Form, Button, Tab, Nav } from "react-bootstrap";
import Dashboardheader from "../directives/dashboardheader";
import {
  ReferralUserList,
  ShowReferralHistory,
  UserProfile,
} from "../Action/user.action";
import CopyToClipboard from "react-copy-to-clipboard";
import Cookies from "js-cookie";
import toast, { Toaster } from "react-hot-toast";
import ReactPaginate from "react-paginate";

const Referral = () => {
  const [getreferral, setreferral] = useState([]);
  const [getuserreferral, setuserreferral] = useState([]);

  const [getreferralcount, setreferralcount] = useState("");
  const [gettotalamountusdt, settotalamountusdt] = useState("");

  const itemsPerPage = 10; // Set the number of items per page
  const [currentPage, setCurrentPage] = useState(0);
  const [userdata, setuserdata] = useState([]);
  const handlePageChange = ({ selected }) => {
    console.log(selected, "selected");
    setCurrentPage(selected);
  };
  const CurrentPageResetFunc = () => {
    setCurrentPage(0);
    handlePageChange({ selected: 0 });
  };
  const totalPages = Math.ceil(getreferral.length / itemsPerPage);
  const totalPagesuserreferral = Math.ceil(
    getuserreferral.length / itemsPerPage
  );

  const isOnFirstPage = currentPage == 0;
  const isOnLastPage = currentPage == totalPages - 1;
  const isOnLastPageuserreferral = currentPage == totalPagesuserreferral - 1;

  const startIndex = currentPage * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const getreferralSliced = getreferral.slice(startIndex, endIndex);
  const getuserreferralSlice = getuserreferral.slice(startIndex, endIndex);

  const loginData = !Cookies.get("loginSuccessStepMrMint", {
    domain: "mrmint.io",
  })
    ? []
    : JSON.parse(
        Cookies.get("loginSuccessStepMrMint", { domain: "mrmint.io" })
      );

  useEffect(() => {
    ReferralFunc();
    getStepMintProfile();
  }, []);

  const copieBtn = async () => {
    toast.success(`Copied!`);
  };

  const getStepMintProfile = async () => {
    let res = await UserProfile();
    if (res.success) {
      setuserdata(res.data);
    } else {
      setuserdata([]);
    }
  };

  const ReferralFunc = async () => {
    let res = await ShowReferralHistory(1);
    let res1 = await ReferralUserList();
    if (res.success) {
      setreferral(res.data.history);
      setreferralcount(res.data.statistics.referral);
      //   setreferralcount(res.data.length)
      //   let totalamount = 0;
      //   for (let i = 0; i < res.data.length; i++) {
      //     totalamount += parseFloat(res.data[i].amount);
      //   }
      //   settotalamountmnt(totalamount);
      let totalamountUSDT = 0;
      for (let i = 0; i < res.data.history.length; i++) {
        totalamountUSDT += parseFloat(res.data.history[i].usdAmount);
      }
      settotalamountusdt(totalamountUSDT);
    } else {
      setreferral([]);
    }
    if (res1.success) {
      setuserreferral(res1.data);
    } else {
      setuserreferral([]);
    }
  };

  return (
    <>
      <Dashboardheader />
      <Toaster />
      <div className="position-relative ">
        <div className="db1"></div>
        {/* <div className="db2"></div> */}
        {/* <div className="db3"></div> */}
        <div className="db4"></div>
        <div className="db5"></div>
        <div className="db6"></div>
        <div className="db7"></div>
        <div className="db8"></div>
        <div className="page-wrapper">
          <div className="position-relative overflow-hidden mt-5 pt-2 mb-5">
            <div className="mb-3">
              <Container className="">
                <Row>
                  <Col lg={12}>
                    <h2 className="text-white sofia-sans" style={{ fontWeight: 600 }}>
                      Referral Reward{" "}
                    </h2>
                  </Col>
                </Row>
              </Container>
            </div>
            {/* -------------------- */}
            <div className="adv-banner mb-4">
              <Container className="">
                <Row>
                  <Col lg={12}>
                    <div className="card card-view overflow-hidden py-2">
                      <div className=" ">
                        <Row className="align-items-center justify-content-center  my-4">
                          <Col lg={10} className="text-center ">
                            <img
                              src="assets/images/mntcoin.png"
                              className="coin coin1"
                            />
                            <img
                              src="assets/images/mntcoin.png"
                              className="coin coin2"
                            />
                            <img
                              src="assets/images/mntcoin.png"
                              className="coin coin3"
                            />
                            <img
                              src="assets/images/mntcoin.png"
                              className="coin coin4"
                            />
                            <img
                              src="assets/images/mntcoin.png"
                              className="coin coin5"
                            />
                            <img
                              src="assets/images/mntcoin.png"
                              className="coin coin6"
                            />

                            {/* <Col lg={6}> */}
                            <Row className="gy-3">
                              <Col lg={6} md={6} sm={12}>
                                <div className="mx-1">
                                  {/* <Form.Label className="text-white">
                                    Referral Link
                                  </Form.Label> */}
                                  <h3 className="mb-3 sofia-sans">Referral Link</h3>
                                  <Form.Group
                                    controlId="formBasicEmail"
                                    className="d-flex align-items-center position-relative px-3"
                                  >
                                    <Form.Control
                                      type="text"
                                      value={
                                        config.refLink +
                                        loginData?.referral_code
                                      }
                                      className="mr-3 custom_field sofia-sans"
                                      style={{ paddingRight: "100px" }}
                                    />

                                    <CopyToClipboard
                                      text={
                                        config.refLink +
                                        loginData?.referral_code
                                      }
                                    >
                                      <Button
                                        variant="btn btn-main2 ml-5 me-3"
                                        onClick={copieBtn}
                                      >
                                        <span
                                          className="mr-copylink sofia-sans"
                                          id="token-buy-button"
                                          style={{ cursor: "pointer" }}
                                        >
                                          Copy
                                        </span>
                                      </Button>
                                    </CopyToClipboard>
                                  </Form.Group>
                                </div>
                              </Col>

                              <Col lg={6} md={6} sm={12}>
                                <div className="mx-1">
                                  {/* <Form.Label className="text-white">
                                    Referral Link
                                  </Form.Label> */}
                                  <h3 className="mb-3 sofia-sans">Referral Code</h3>
                                  <Form.Group
                                    controlId="formBasicEmail"
                                    className="d-flex align-items-center position-relative px-3"
                                  >
                                    <Form.Control
                                      type="text"
                                      value={loginData?.referral_code}
                                      className="mr-3 custom_field sofia-sans"
                                      style={{ paddingRight: "100px" }}
                                    />

                                    <CopyToClipboard
                                      text={loginData?.referral_code}
                                    >
                                      <Button
                                        variant="btn btn-main2 ml-5 me-3"
                                        onClick={copieBtn}
                                      >
                                        <sapn
                                          className="mr-copylink"
                                          id="token-buy-button"
                                          style={{ cursor: "pointer" }}
                                        >
                                          Copy
                                        </sapn>
                                      </Button>
                                    </CopyToClipboard>
                                  </Form.Group>
                                </div>
                              </Col>
                            </Row>

                            {/* </Col> */}
                          </Col>
                          <Col lg={6} className="text-center">
                            <img
                              src="assets/images/mntcoin.png"
                              className="coin coin1"
                            />
                            <img
                              src="assets/images/mntcoin.png"
                              className="coin coin2"
                            />
                            <img
                              src="assets/images/mntcoin.png"
                              className="coin coin3"
                            />
                            <img
                              src="assets/images/mntcoin.png"
                              className="coin coin4"
                            />
                            <img
                              src="assets/images/mntcoin.png"
                              className="coin coin5"
                            />
                            <img
                              src="assets/images/mntcoin.png"
                              className="coin coin6"
                            />
                          </Col>
                          {/* <Col lg={6} className="mb-3 text-center">
                                <div className="referral_animation">
                                    <img src="assets/images/referral_animation.gif"  />
                                 </div>
                              </Col> */}
                        </Row>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
            {/* ---------- */}
            <div>
              <Container>
                <Row className="justify-content-end">
                  <Col lg={7}>
                    {/* <div className="d-flex align-items-center">
                  <h5 className="mb-3">Referred By</h5>
                  <Form.Group
                    controlId="formBasicEmail"
                    className="position-relative w-100"
                  >
                    <Form.Control
                      type="text"
                      value={
                        userdata.referredBy == null ||
                        userdata.referredBy == undefined ||
                        userdata.referredBy == ""
                          ? "No Referral"
                          : userdata.referredBy
                      }
                      className="mr-3 custom_field"
                    />
                    {userdata.referredBy == null ||
                    userdata.referredBy == undefined ||
                    userdata.referredBy == "" ? (
                      ""
                    ) : (
                      <CopyToClipboard text={userdata.referredBy}>
                        <Button variant="btn btn-main2 ml-5" onClick={copieBtn}>
                          <sapn
                            className="mr-copylink"
                            id="token-buy-button"
                            style={{ cursor: "pointer" }}
                          >
                            Copy
                          </sapn>
                        </Button>
                      </CopyToClipboard>
                    )}
                  </Form.Group>
                </div> */}
                  </Col>
                </Row>
              </Container>
            </div>
            <div className=" mb-5">
              <div className="container referral">
                <div className="mr-referral-content">
                  <div className="mr-referral-block">
                    <Row className="sofia-sans">
                      <Col lg={5} md={12} className="">
                        <div className="mr-referral-carditem mr-referralref-item buyform card-view1  mb-4">
                          <div className="mr-referral-inner">
                            <div className="mr-contant-block">
                              <h4>
                                <Row >
                                  <Col lg={4} sm={5} xs={5}>
                                    {" "}
                                    Direct Refers
                                  </Col>
                                  <Col lg={8} sm={7} xs={7}>
                                    <div className="d-flex">
                                      <span className="seprator"> : </span>
                                      <span className="text text-break ">
                                        {getreferralcount}
                                      </span>
                                    </div>
                                  </Col>
                                </Row>
                              </h4>

                              <h4>
                                <Row>
                                  <Col lg={4} sm={5} xs={5}>
                                    Total Income
                                  </Col>
                                  <Col lg={7} sm={7} xs={7} className="d-flex">
                                    <span className="seprator"> : </span>
                                    <span className="text text-break ">
                                       ${gettotalamountusdt}
                                    </span>
                                  </Col>
                                </Row>
                              </h4>
                              <h4>
                                <Row>
                                  <Col lg={4} sm={5} xs={5}>
                                    {" "}
                                    Email
                                  </Col>
                                  <Col lg={8} sm={7} xs={7} className="d-flex">
                                    <span className="seprator"> : </span>
                                    <span className="text text-white text-break">
                                      {loginData?.email}
                                    </span>
                                  </Col>
                                </Row>
                              </h4>
                              <h4>
                                <Row>
                                  <Col lg={4} sm={5} xs={5}>
                                    {" "}
                                    Referred By
                                  </Col>
                                  <Col lg={8} sm={7} xs={7} className="d-flex">
                                    <span className="seprator"> : </span>
                                    <span className="text text-white text-break fs-6">
                                      <span
                                        type="text"
                                        className="mr-3   border-0 pl-0 h-auto"
                                      >
                                        {userdata.referredBy == null ||
                                        userdata.referredBy == undefined ||
                                        userdata.referredBy == ""
                                          ? "No Referral"
                                          : userdata.referredBy}
                                      </span>
                                    </span>
                                  </Col>
                                </Row>
                              </h4>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col lg={7} md={12} className=" sofia-sans ">
                        <div className="mr-referral-carditem mr-referral-item buyform  card-view1 px-md-5 py-1">
                          <div className="mr-contant-block">
                            <div className="text-center">
                              <img
                                src="assets/images/phnchain.png"
                                width={130}
                                className="img-fluid h-auto mb-2"
                              />
                            </div>
                            <h4 className="">Referral System</h4>
                            <ul className="mr-referralsteps ps-0">
                              <li className="mr-referralsteps-item mr-referral-item1">
                                <div className="mr-stepsinfo">
                                  <div className="mr-inner-stepinfo">
                                    <h4>Refer your Friends</h4>
                                  </div>
                                  <span className="mr-step-counter">
                                    <span className="mr-step-counter-inner">
                                      1
                                    </span>
                                  </span>
                                </div>
                              </li>
                              <li className="mr-referralsteps-item mr-referral-item2">
                                <div className="mr-stepsinfo">
                                  <div className="mr-inner-stepinfo">
                                    <h4>They Purchase Plan</h4>
                                  </div>
                                  <span className="mr-step-counter">
                                    <span className="mr-step-counter-inner">
                                      2
                                    </span>
                                  </span>
                                </div>
                              </li>
                              <li className="mr-referralsteps-item mr-referral-item3">
                                <div className="mr-stepsinfo">
                                  <div className="mr-inner-stepinfo">
                                    <h4>You start Earning</h4>
                                  </div>
                                  <span className="mr-step-counter">
                                    <span className="mr-step-counter-inner">
                                      3
                                    </span>
                                  </span>
                                </div>
                              </li>
                            </ul>
                            <p>
                              Welcome to the Referral System. By becoming a
                              referrer and inviting friends, you will receive 5%
                              of their purchased plan amount each time they make
                              a purchase.
                            </p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* ---------- */}

            <div className="latest_transaction mt-3 mb-5">
              <Container className="">
                <Row className="sofia-sans">
                  <Col lg={12}>
                    <Tab.Container
                      id="left-tabs-example"
                      defaultActiveKey="history"
                    >
                      <Row>
                        <Col lg={12}>
                          <Nav variant="pills" className="">
                            <Row
                              className=" text-center mb-4"
                              style={{ width: "100vw" }}
                            >
                              <Col lg={6} sm={6} className="text-nowrap">
                                <Nav.Item>
                                  <Nav.Link
                                    eventKey="history"
                                    className="card-view1 customnav-link"
                                    onClick={CurrentPageResetFunc}
                                  >
                                    History
                                  </Nav.Link>
                                </Nav.Item>
                              </Col>
                              <Col lg={6} sm={6} className="text-nowrap">
                                <Nav.Item>
                                  <Nav.Link
                                    eventKey="referral_user"
                                    className="card-view1 customnav-link "
                                    onClick={CurrentPageResetFunc}
                                  >
                                    Referral User List
                                  </Nav.Link>
                                </Nav.Item>
                              </Col>
                            </Row>
                          </Nav>
                        </Col>
                        <Col sm={12} className="mt-3">
                          <Tab.Content>
                            <Tab.Pane eventKey="history">
                              <div className="table-responsive">
                                <table
                                  width="100%"
                                  className="text-center card-view sofia-sans"
                                >
                                  {/* <colgroup>
                                    <col className="col-md-4">
                                    <col className="col-md-7">
                                    </colgroup> */}
                                  <thead>
                                    <tr className="table-head">
                                      <th>S.No</th>
                                      <th>NFT Name</th>

                                      <th>Referral %</th>
                                      <th>Amount</th>
                                      <th>Joining Date</th>
                                    </tr>
                                  </thead>
                                  <tbody className="">
                                    {getreferral.length == 0 ? (
                                      <tr className="tr_list">
                                        {/* <td></td> */}
                                        {/* <td></td> */}
                                        <td colSpan="6">
                                          No History Available
                                        </td>
                                        {/* <td></td> */}
                                        {/* <td></td> */}
                                      </tr>
                                    ) : (
                                      getreferralSliced.map((item, index) => (
                                        <tr className="tr_list">
                                          <td>
                                            {index +
                                              1 +
                                              currentPage * itemsPerPage}
                                          </td>
                                          <td>{item.name}</td>
                                          {/* <td>{item.description}</td> */}
                                          <td>
                                            {parseInt(item.referralPercent)}%
                                          </td>
                                          <td>
                                            $
                                            {parseFloat(
                                              item.usdAmount
                                            )?.toFixed(2)}
                                            ~
                                            {parseFloat(item.amount)?.toFixed(
                                              2
                                            )}
                                            &nbsp;MNT
                                          </td>
                                          <td>{item.datetime}</td>
                                        </tr>
                                      ))
                                    )}
                                  </tbody>
                                </table>
                                {getreferral.length > itemsPerPage && (
                                  <div className="pagination-container">
                                    <ReactPaginate
                                      previousLabel="Previous"
                                      nextLabel="Next"
                                      previousClassName={
                                        isOnFirstPage ? "btn  disabled" : ""
                                      }
                                      nextClassName={
                                        isOnLastPage ? "btn  disabled" : ""
                                      }
                                      previousLinkClassName={
                                        isOnFirstPage ? "disabled-link" : ""
                                      }
                                      nextLinkClassName={
                                        isOnLastPage ? "disabled-link" : ""
                                      }
                                      breakLabel={"..."}
                                      pageCount={Math.ceil(
                                        getreferral.length / itemsPerPage
                                      )}
                                      marginPagesDisplayed={2}
                                      pageRangeDisplayed={5}
                                      onPageChange={handlePageChange}
                                      containerClassName={"pagination"}
                                      activeClassName={"active"}
                                      forcePage={currentPage}
                                    />
                                  </div>
                                )}
                              </div>
                            </Tab.Pane>
                            <Tab.Pane eventKey="referral_user">
                              <div className="table-responsive">
                                <table
                                  width="100%"
                                  className="text-center card-view sofia-sans "
                                >
                                  <thead>
                                    <tr className="table-head">
                                      <th>S.No</th>
                                      <th>Email</th>
                                      {/* <th>Referral Count</th> */}
                                      <th>Package Count</th>
                                      <th>Purchase Amount</th>
                                      <th>BNB Address</th>
                                    </tr>
                                  </thead>
                                  <tbody className="">
                                    {getuserreferral.length == 0 ? (
                                      <tr className="tr_list">
                                        {/* <td></td> */}
                                        {/* <td></td> */}
                                        <td colSpan="5">No List Available</td>
                                        {/* <td></td> */}
                                      </tr>
                                    ) : (
                                      getuserreferralSlice.map(
                                        (item, index) => (
                                          <tr className="tr_list">
                                            <td>
                                              {index +
                                                1 +
                                                currentPage * itemsPerPage}
                                            </td>
                                            <td>{item.email}</td>
                                            {/* <td>{item.nftReferralCount}</td> */}
                                            <td>{item.packageCount}</td>
                                            <td>
                                              {parseFloat(item.purchaseAmount)}
                                            </td>
                                            <td>
                                              {" "}
                                              {item.bnb_address == "NA" ? (
                                                item.bnb_address
                                              ) : (
                                                <span className="text-gradien ">
                                                  <b>
                                                    {" "}
                                                    <span className="text-sm text-bold text-light">
                                                      {item.bnb_address?.slice(
                                                        0,
                                                        4
                                                      ) +
                                                        "...." +
                                                        item.bnb_address?.slice(
                                                          -4
                                                        )}{" "}
                                                    </span>
                                                    <CopyToClipboard
                                                      text={item.bnb_address}
                                                    >
                                                      <span
                                                        title="Click to Copy"
                                                        className="mr-copylink ms-2"
                                                        id="token-buy-button"
                                                        onClick={copieBtn}
                                                        style={{
                                                          cursor: "pointer",
                                                          color:
                                                            "rgb(157 81 255)",
                                                        }}
                                                      >
                                                        <i className="fa fa-clone "></i>
                                                      </span>
                                                    </CopyToClipboard>
                                                  </b>
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                        )
                                      )
                                    )}
                                  </tbody>
                                </table>
                                {getuserreferral.length > itemsPerPage && (
                                  <div className="pagination-container">
                                    <ReactPaginate
                                      previousLabel="Previous"
                                      nextLabel="Next"
                                      previousClassName={
                                        isOnFirstPage ? "btn  disabled" : ""
                                      }
                                      nextClassName={
                                        isOnLastPageuserreferral
                                          ? "btn  disabled"
                                          : ""
                                      }
                                      previousLinkClassName={
                                        isOnFirstPage ? "disabled-link" : ""
                                      }
                                      nextLinkClassName={
                                        isOnLastPageuserreferral
                                          ? "disabled-link"
                                          : ""
                                      }
                                      breakLabel={"..."}
                                      pageCount={Math.ceil(
                                        getuserreferral.length / itemsPerPage
                                      )}
                                      marginPagesDisplayed={2}
                                      pageRangeDisplayed={5}
                                      onPageChange={handlePageChange}
                                      containerClassName={"pagination"}
                                      activeClassName={"active"}
                                      forcePage={currentPage}
                                    />
                                  </div>
                                )}
                              </div>
                            </Tab.Pane>
                          </Tab.Content>
                        </Col>
                      </Row>
                    </Tab.Container>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Referral;
